"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignTaskButton = AssignTaskButton;
var jsx_runtime_1 = require("react/jsx-runtime");
var button_component_1 = require("../../ui/button-component");
function AssignTaskButton(props) {
    var task = props.task, onAssign = props.onAssign;
    if (!task.canAssign || !onAssign) {
        return null;
    }
    var isComplete = task.status === "COMPLETE";
    var label = task.assignedTo ? "Reassign" : "Assign";
    return ((0, jsx_runtime_1.jsx)("span", { title: isComplete ? "A completed task cannot be reassigned." : undefined, className: "inline-flex", children: (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "", ariaLabel: "".concat(label, " ").concat(task.taskId || task.title), icon: "solar:user-plus-linear", iconSize: 16, isDisabled: isComplete, onPress: function () { return onAssign(task); }, variant: "ghost", className: "text-medium-gray hover:text-primary-navy transition-colors" }) }));
}
